<h1 mat-dialog-title>{{ 'MODAL_ASK_GUEST_EMAIL.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <div>
    <p>{{ 'MODAL_ASK_GUEST_EMAIL.MESSAGE' | translate }}</p>
  </div>
  <form>
    <mat-form-field style="display:inline">
      <mat-label>{{ 'MODAL_ASK_GUEST_EMAIL.LABEL' | translate }}</mat-label>
      <input type="email" matInput [formControl]="userEmail" (keyup.enter)="checkReturn()"
        placeholder="{{ 'MODAL_ASK_GUEST_EMAIL.PLACEHOLDER' | translate }}">
        @if ((userEmail.hasError('email') || userEmail.hasError('completeEmail')) && !userEmail.hasError('required')) {
          <mat-error
            >
            {{ 'MODAL.INVALID_EMAIL' | translate }}
          </mat-error>
        }
        @if (userEmail.hasError('required')) {
          <mat-error>
            {{ 'MODAL_ASK_GUEST_EMAIL.REQUIRED_EMAIL_ERROR' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="acceptNameChanged()">{{ 'MODAL.ACCEPT' | translate }}</button>
  </div>
